import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AngularFirestore } from "@angular/fire/firestore";
import { API_URL } from "src/app/config/config";
import { Schedule } from "src/app/models/schedule.model";

@Injectable({
  providedIn: "root",
})
export class ScheduleService {
  constructor(private afs: AngularFirestore, public http: HttpClient) {}

  getSchedule() {
    return this.afs
      .collection("businesses/root/schedule/educative/days/1/items")
      .get();
  }

  setSchedule(category: string, schedule: any) {
    return this.afs
      .collection("businesses/root/schedule")
      .doc(category)
      .set(schedule, { merge: true });
  }

  getScheduleByDay(day: string) {
    return this.afs.collection("businesses/root/schedule").doc(day).get();
  }

  getUsersAFS() {
    return this.afs
      .collection("businesses/root/schedule", (ref) =>
        ref.limit(20).orderBy("cdate", "desc")
      )
      .valueChanges();
  }

  createEducationSchedule(schedule: Schedule) {
    return this.afs
      .collection("businesses/root/schedule/educative/days/1/items")
      .add({
        title: schedule.title,
        subTitle: schedule.title,
        link: schedule.link,
        hour: schedule.hour,
        hourToIndent: schedule.hour,
      });
  }
  createOperativeSchedule(schedule: Schedule) {
    return this.afs
      .collection("businesses/root/schedule/operative/days/1/items")
      .add({
        title: schedule.title,
        subTitle: schedule.title,
        link: schedule.link,
        hour: schedule.hour,
        hourToIndent: schedule.hour,
      });
  }
  createNovalogicSchedule(schedule: Schedule) {
    return this.afs
      .collection("businesses/root/schedule/onecore/days/1/items")
      .add({
        title: schedule.title,
        subTitle: schedule.title,
        link: schedule.link,
        hour: schedule.hour,
        hourToIndent: schedule.hour,
      });
  }
}
